import React from 'react';

export const CommentIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="94" height="72" viewBox="0 0 94 72">
    <path d="M58.5 54.5H74c10.217 0 18.5-8.283 18.5-18.5V20C92.5 9.783 84.217 1.5 74 1.5H20C9.783 1.5 1.5 9.783 1.5 20v16c0 10.217 8.283 18.5 18.5 18.5h8.354L58.5 69.573V54.5zM20 0h54c11.046 0 20 8.954 20 20v16c0 11.046-8.954 20-20 20H60v14.382a1 1 0 0 1-1.447.894L28 56h-8C8.954 56 0 47.046 0 36V20C0 8.954 8.954 0 20 0zm.25 21.25h50.5v-1.5h-50.5v1.5zm0 14h27.5v-1.5h-27.5v1.5z" />
  </svg>
);
